import { useSyncExternalStore } from "react";

/**
 * Progresso do envio de uma nova solicitação (criação → anexos → próxima etapa), exibido pelo
 * EnvioProgressoOverlay em tela cheia — equivalente web do EnvioProgressoModal do app. A página
 * Nova Solicitação inicia/finaliza; o envio de anexos (anexosStaged.js) só atualiza, e as
 * atualizações são ignoradas quando não há envio em andamento (ex.: anexo enviado pelo detalhe).
 */
let estado = null;
const ouvintes = new Set();

function emitir(novo) {
    estado = novo;
    ouvintes.forEach(ouvir => ouvir());
}

export function iniciarProgressoEnvio(titulo, subtitulo = "") {
    emitir({ titulo, subtitulo, anexoAtual: 0, totalAnexos: 0, arquivo: null, percentualArquivo: 0 });
}

export function atualizarProgressoEnvio(parcial) {
    if (!estado) return;
    emitir({ ...estado, ...parcial });
}

export function finalizarProgressoEnvio() {
    if (estado) emitir(null);
}

function assinar(ouvir) {
    ouvintes.add(ouvir);
    return () => ouvintes.delete(ouvir);
}

export function useProgressoEnvio() {
    return useSyncExternalStore(assinar, () => estado);
}
